// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-page-password_reset_confirmation .w-layout-modal__heading{justify-content:space-between}.w-page-password_reset_confirmation .w-layout-modal__heading .heading-metadatas-container{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
